export function PopeIcon({ label, size = 20 }: { label?: string; size?: number }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : "true"}
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      className="pope-icon"
    >
      <path data-pope-mitre className="pope-icon__mitre" d="M6 25.5 8.5 12 16 5l7.5 7 2.5 13.5H6Z" fill="#66BA50" stroke="#407d34" strokeWidth="1.3" strokeLinejoin="round" />
      <path className="pope-icon__band" d="M7.8 18h16.4M6.8 23h18.4" fill="none" stroke="#fff" strokeOpacity=".84" strokeWidth="1.4" />
      <path data-pope-cross className="pope-icon__cross" d="M16 1.8v8.4M12.4 5h7.2" fill="none" stroke="#0BA4F9" strokeWidth="1.8" strokeLinecap="round" />
      <circle data-pope-jewel className="pope-icon__jewel" cx="16" cy="15.1" r="2.1" fill="#0BA4F9" stroke="#f8f1e2" strokeWidth=".8" />
      <path className="pope-icon__stole" d="m11.4 19.3 2.4 2.2-1.1 5.1-3.2-1.3 1.9-6Zm9.2 0-2.4 2.2 1.1 5.1 3.2-1.3-1.9-6Z" fill="#0BA4F9" stroke="#095f94" strokeWidth=".8" strokeLinejoin="round" />
      <path className="pope-icon__hem" d="M4.5 27h23" stroke="#407d34" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
